export function isIncapsulaRequest(request) {
  // if request is from incapsula, we return the src
  if (/Incapsula/gm.test(request)) {
    return request.match(/<iframe[^>]+src="([^"]+)"/m)[1]
  }
  return false
}
